import User from '@/services/api/user.js';

export default {
  namespaced: true,
  state: {
    users: [],
    settingsTables: [],
    settingTable: {},
    user: {},
  },
  getters: {
    users: state => state.users,
    settingsTables: state => state.settingsTables,
    settingTable: state => state.settingTable,
    user: state => state.user,
  },
  mutations: {
    setUsers: (state, users) => {
      state.users = users;
    },
    setUser: (state, user) => {
      state.user = user;
    },
    setSettingTable: (state, settingTable) => {
      state.settingTable = settingTable;
    },
    setSettingsTables: (state, settingsTables) => {
      state.settingsTables = settingsTables;
    },
  },
  actions: {
    loadUsers (state, options = {}) {
      return new Promise((resolve, reject) => {
        User.getUsers(options)
          .then(({ data }) => {
            state.commit('setUsers', data.users);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    loadUser (state, id) {
      return new Promise((resolve, reject) => {
        User.getUser(id)
          .then(({ data }) => {
            state.commit('setUser', data.user);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateUser (state, payload) {
      return new Promise((resolve, reject) => {
        User.updateUser(payload)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    toggleBlockUser (state, payload) {
      return new Promise((resolve, reject) => {
        User.toggleBlockUser(payload)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    newUser (state, params) {
      return new Promise((resolve, reject) => {
        User.newUser(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    deleteUser (state, id) {
      return new Promise((resolve, reject) => {
        User.deleteUser(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => console.error(e));
      });
    },
    getAllSettingsTables (state) {
      return new Promise((resolve, reject) => {
        User.getAllSettingsTables()
          .then(({ data }) => {
            state.commit('setSettingsTables', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    showSettingTable ({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        User.showSettingTable(id, data)
          .then(({ data }) => {
            commit('setSettingTable', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateSettingTable (state, payload) {
      return new Promise((resolve, reject) => {
        User.updateSettingTable(payload)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
